<template>
  <div v-loading="loading" class="mainDiv">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="">
        <el-input v-model="search.uname" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="search.fullName"
          placeholder="请输入考生姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="search.examsPaperTitle"
          placeholder="请输入试卷名"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布状态">
        <el-select v-model="search.publishStatus" placeholder="请选择发布状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="未发布" value="0"></el-option>
          <el-option label="已发布" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="exportScore">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="batch">成绩发布</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showImportDialog = true"
          >导入平时成绩</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData1"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj1.page - 1) * pageObj1.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="examsPaperTitle" label="试卷名"></el-table-column>
      <el-table-column prop="fullName" label="用户"></el-table-column>
      <el-table-column prop="uname" label="姓名"></el-table-column>
      <el-table-column prop="videoTitle" label="关联点播课程"></el-table-column>
      <el-table-column prop="usuallyScore" label="平时成绩">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.videoTitle === null && scope.row.usuallyScore === null
            "
          >
            待导入
          </div>
          <div v-else>
            {{ scope.row.usuallyScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="examScore" label="考试成绩"></el-table-column>
      <el-table-column prop="finalScore" label="最终成绩"></el-table-column>
      <el-table-column prop="examsTime" label="考试时间" width="150">
      </el-table-column>
      <!-- <el-table-column label="本次考试成绩">
        <template slot-scope="scope">
          <span v-if="scope.row.scoreStatus == 0">待审核</span>
          <span v-if="scope.row.scoreStatus == 1">成绩有效</span>
          <span v-if="scope.row.scoreStatus == 2">成绩无效</span>
        </template>
      </el-table-column> -->
      <el-table-column label="发布状态">
        <template slot-scope="scope">
          <span v-if="scope.row.publishStatus == 0">未发布</span>
          <span v-if="scope.row.publishStatus == 1">已发布</span>
        </template>
      </el-table-column>
      <el-table-column prop="publishFullName" label="发布人"></el-table-column>
      <el-table-column prop="publishTime" label="发布时间"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj1.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj1.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <el-dialog title="导入文件" :visible.sync="showImportDialog">
      <el-form>
        <el-form-item label="下载模板" :label-width="'140px'">
          <el-button size="small" type="primary" @click="downloadModel"
            >下载模板</el-button
          >
        </el-form-item>
        <el-form-item label="选择要导入的文件" :label-width="'140px'">
          <el-upload
            class="upload-demo"
            :action="url + '/zkfz/notice/saveOrUpdate'"
            ref="upload"
            :auto-upload="false"
            :on-change="handleChange"
            accept=""
            :file-list="file"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImportDialog = false">取 消</el-button>
        <el-button type="primary" @click="importFile">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/exam/exam'

export default {
  name: 'ExamScoreList',
  data() {
    return {
      paperId: '',
      examinerId: '',
      createBy: '',
      activeTab: '考试进行中',
      loading: false,
      readStatusList: [
        { value: '', label: '请选择' },
        { value: '2', label: '已评阅' },
        { value: '1', label: '待批阅' },
        // { value: '3', label: '未提交' }
      ],
      search: {
        uname: '',
        fullName: '',
        publishStatus: '',
        examsPaperTitle: '',
      },
      tableData1: [],
      // 分页
      pageObj1: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      showImportDialog: false,
      file: [],
      isShowDialogNotPass: false,
    }
  },
  methods: {
    getData() {
      let that = this
      let reqdata = {
        uname: this.search.uname,
        fullName: this.search.fullName,
        publishStatus: this.search.publishStatus,
        examsPaperTitle: this.search.examsPaperTitle,
        createBy: this.createBy,
        page: this.pageObj1.page,
        pageSize: this.pageObj1.pageSize,
      }
      api.getPageByExamsUsersScore(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.tableData1 = data.data.list
          this.total = data.data.total
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //分页
    handleSizeChange(val) {
      this.pageObj1.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageObj1.page = val
      this.getData()
    },
    //    批量操作
    batch() {
      this.$confirm('是否发布这些成绩？').then((_) => {
        const alldata = this.$refs.multipleTable.selection
        console.log(alldata)
        let allId = ''
        for (let i of alldata) {
          if (allId == '') {
            allId += '' + i.examsUsersId
          } else {
            allId += ',' + i.examsUsersId
          }
        }
        let reqdata = {
          examsUsersIds: allId,
          publishUid: this.getUId,
        }
        console.log(reqdata)
        if (alldata.length == 0) {
          this.$message.error('请勾选')
        } else {
          this.publishScore(reqdata)
        }
      })
    },
    // 文件流下载
    downloadStream(method = 'GET', url, downloadName) {
      let xmlResquest = new XMLHttpRequest()
      xmlResquest.open(method, url, true)
      xmlResquest.setRequestHeader(
        'Content-type',
        'application/json;charset=UTF-8'
      )
      //这里需要在请求头添加该参数，已防止CSRF
      // xmlResquest.setRequestHeader("csrfToken", hashStr(ctoken));
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        let content = xmlResquest.response
        console.log(content, 'content')
        let elink = document.createElement('a')
        elink.download = downloadName
        elink.style.display = 'none'
        let blob = new Blob([content])
        console.log(blob, 'blob')
        elink.href = URL.createObjectURL(blob)
        console.log(elink.href, 'elink.href')
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
    },
    // 导出
    exportScore() {
      let reqdata = {
        uname: this.search.uname,
        fullName: this.search.fullName,
        publishStatus: this.search.publishStatus,
        examsPaperTitle: this.search.examsPaperTitle,
        createBy: this.createBy,
      }
      // let urlFirst = window.location.protocol + window.location.host  iframe中会出现问题
      // if (window.location.host == 'localhost:5001') {
      //   urlFirst = 'http://gz.hnjk.net'
      // }
      let search = this.search
      let url = `${this.url}/zkfz/elExamsUsersScore/exportExcel?uname=${search.uname}&fullName=${search.fullName}&publishStatus=${search.publishStatus}&examsPaperTitle=${search.examsPaperTitle}&createBy=${this.createBy}`
      this.downloadStream('GET', url, `成绩.xlsx`)
      // api.exportExcel(reqdata).then(({ data }) => {
      //   if (data) {
      //     console.log(data)
      //   } else {
      //     this.$message.error('导出失败')
      //   }
      // })
    },
    // 下载导入模板
    downloadModel() {
      // let urlFirst = window.location.protocol + window.location.host  //iframe嵌套会出现问题
      // if (window.location.host == 'localhost:5001') {
      //   urlFirst = 'http://gz.hnjk.net'
      // } else if (urlFirst.indexOf('dist') > -1) {
      //   urlFirst =
      //     window.location.protocol +
      //     urlFirst.substr(urlFirst.indexOf('dist') + 5)
      // }
      let url = `${this.url}/zkfz/elExamsUsersScore/exportExcelModel`
      this.downloadStream('GET', url, `成绩模板.xlsx`)
      // api.exportExcelModel().then(({ data }) => {
      //   if(data){
      //     console.log(data)
      //     this.downloadFile(data,'vnd.ms-excel','模板')
      //   }else{
      //     this.$message.error('导出失败');
      //   }
      // });
    },
    // 文件作出改变
    handleChange(file, fileList) {
      this.file = file.raw
      console.log(file)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    importFile() {
      let reqdata = {
        createBy: this.createBy,
      }
      let filedata = this.file
      api.importScroce(reqdata, filedata).then(({ data }) => {
        if (data.code == 100000) {
          this.getData()
          this.showImportDialog = false
          this.$message({ message: '导入成功', type: 'success' })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    publishScore(reqdata) {
      api.publishScore(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.search.publishStatus = '1'
          this.getData()
          this.$message({ message: '发布成功', type: 'success' })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    invigilate(examsUsersId) {
      this.$router.push({
        name: 'InvigilateDetails',
        query: { exams_users_id: examsUsersId, examiner_id: this.examinerId },
      })
    },
  },
  mounted() {
    this.createBy = this.$route.query.createBy || ''
    this.getData()
    // this.downloadModel()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.exam-name {
  font-size: 22px;
  font-weight: 700;
}
.head-left {
  border-left: 5px solid #2f527b;
  padding-left: 10px;
}
.head-right {
  padding: 10px;
  background-color: #ed5900;
  color: white;
}
</style>
